import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 导入i18n配置
import './i18n'

// 开发环境下启用MSW
if (import.meta.env.DEV) {
  import('./mocks/setup')
    .then(({ worker }) => worker.start())
    .catch(err => console.error('Failed to start MSW:', err))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
